module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[115]480.c04dbfa.woff2";